import Notification from './Notification';
export default Notification;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_rc-notification@3.1.1@rc-notification/es/index.js
// module id = 290
// module chunks = 0 1